import Axios from "axios";

async function claimPro(token, email) {
  const opt = {
    method: "PATCH",
    url: `${
      process.env.REACT_APP_AWS_SERVERLESS
    }/users/usergroup?user=${encodeURIComponent(email)}&token=${token}`,
  };

  try {
    return await Axios(opt);
  } catch (e) {
    return e.response;
  }
}

export async function setUsersContactPreferences(context, onOrOff) {
  const opt = {
    method: "PATCH",
    url: `${
      process.env.REACT_APP_API_URL
    }/items/notifications/@me?token=${localStorage.getItem("token")}`,
    data: {
      context: context,
      status: onOrOff === "on" ? true : false,
    },
  };
  try {
    return await Axios(opt);
  } catch (e) {
    return e.response;
  }
}
